import axios from "axios";
import { PAGE_SIZE } from "consts";
import {
  DataGridRequestParams,
  TransferListItem,
  TransferResponse,
} from "../../../types";

export const getTransfers = (
  queryKey: string,
  requestParams: DataGridRequestParams,
  companyId?: number,
  page: number | null = 1
) => {
  return axios
    .post<TransferResponse<TransferListItem>>(
      "getTransfers",
      {
        ...requestParams,
        ...(page !== null
          ? { limit: PAGE_SIZE, skip: PAGE_SIZE * (page - 1) }
          : {}),
      },
      { params: { companyId } }
    )
    .then((res) => res.data);
};

export default getTransfers;
